import o from "../../../node_modules/prop-types/index.es.js";
import a, { css as i } from "styled-components";
const r = a.div.withConfig({
  displayName: "AspectRatioBox",
  componentId: "sc-92ijd5-0"
})(["position:relative;width:100%;", " ", " & > *{bottom:0;left:0;position:absolute;right:0;top:0;}"], ({
  ratio: t = "1:1"
}) => {
  const [s, e] = t.split(":"), p = Number(s), n = Number(e);
  return i(["padding-bottom:", "%;"], 100 / (p / n));
}, ({
  backgroundColor: t = "transparent"
}) => i(["background-color:", ";"], t)), c = {
  ratio: o.string,
  backgroundColor: o.string
};
r.displayName = "AspectRatioBox";
r.propTypes = c;
export {
  r as AspectRatioBox,
  c as aspectRatioBoxPropTypes
};
//# sourceMappingURL=AspectRatioBox.es.js.map
